import React from 'react';
import { strings } from '../../../resources/strings';
import { useOrdersInTransportTable } from './useOrdersInTransportTable';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';

interface IOrdersInTransportTableHeaderProps {
}

const OrdersInTransportTableHeader: React.FC<IOrdersInTransportTableHeaderProps> = ({
}) => {

  const { getWidthColumns } = useOrdersInTransportTable();

  const widthColumn = getWidthColumns();

  return (
    <tr>
      <td style={{ width: widthColumn.FulfilledBy, minWidth: widthColumn.FulfilledBy, maxWidth: widthColumn.FulfilledBy }}>
        <FontAwesomeIcon icon={faMapMarkerAlt} color='#74777a' size='sm' />
      </td>
      <th style={{ width: widthColumn.OrderNumber, minWidth: widthColumn.OrderNumber, maxWidth: widthColumn.OrderNumber }}>{strings.OrderNum}</th>
      <th style={{ width: widthColumn.CarrierNameTitle, minWidth: widthColumn.CarrierNameTitle }}>{strings.Carrier}</th>
      <th style={{ width: widthColumn.ClientNameTitle }}>{strings.ClientName}</th>
      <th style={{ width: widthColumn.CurrentStateDescriptionTitle }}>{strings.StateOrder}</th>
      <th style={{ width: widthColumn.VirtualCollectTitle }}>{strings.VirtualCollect}</th>
      <th style={{ width: widthColumn.LastConsultTitle }}>{strings.LastConsult}</th>
      <th style={{ width: widthColumn.LastStatusPackageTitle }}>{strings.LastStatus}</th>
      <th style={{ textAlign: 'right', width: widthColumn.OptionsTitle, minWidth: widthColumn.OptionsTitle }}>{strings.Options}</th>
    </tr>
  );
}

export { OrdersInTransportTableHeader };